import { Injectable, NgZone } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { take } from 'rxjs/operators';
import { CommandService } from '@core/services/command.service';
import { DataMappingDeactivateWarningService } from '@features/data-mapping/services/data-mapping-deactivate-warning.service';

@Injectable()
export class DataMappingCanDeactivateGuard implements CanDeactivate<unknown> {
  constructor(
    private dataMappingDeactivateWarningService: DataMappingDeactivateWarningService,
    private commandService: CommandService,
    private ngZone: NgZone
  ) {}

  canDeactivate(): boolean | Promise<boolean> {
    const primaryCount = this.dataMappingDeactivateWarningService.getPrimaryCount();
    if (primaryCount === null || primaryCount >= 1) {
      return true;
    }
    // Only prompt when there are field rows in Unmapped / Mapped / Aggregate (same bar totals as EditDataMappingComponent).
    const mappingBucketsTotal =
      this.dataMappingDeactivateWarningService.getUnmappedMappedAggregateTotal() ?? 0;
    if (mappingBucketsTotal === 0) {
      return true;
    }
    // First button = 'Select' (stay on page), second = 'Close' (route to destination). showConfirmDialog returns action 'OK' for first button, 'Cancel' for second.
    const dialog$ = this.commandService.dialogService.showConfirmDialog(
      'Warning',
      'Select',
      'Close',
      'Please select the primary keys.',
      ''
    );
    return new Promise<boolean>((resolve) => {
      let settled = false;
      const done = (result?: { action?: string }) => {
        if (!settled) {
          settled = true;
          // action 'OK' = Select = stay; action 'Cancel' = Close = allow navigation
          const allowNavigation = result?.action === 'Cancel';
          this.ngZone.run(() => resolve(allowNavigation));
        }
      };
      dialog$.pipe(take(1)).subscribe({
        next: (result) => done(result),
        complete: () => done(),
        error: () => done()
      });
    });
  }
}
